import { useSelector } from "react-redux";
import IdleWatcher from "../../Hooks/idleWatcher";
import { useNavigate } from "react-router-dom";
import { getAppSettings, getCurrentUserData, RootState } from "../../Redux/store";
interface FooterProps {
  alignment: 'start' | 'center' | 'end' | 'between';
}

export function Footer({ alignment }: FooterProps) {
     const navigate = useNavigate();
     const appSettings: any = useSelector(
        (state: RootState) => { return getAppSettings(state) || {} }
        )
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state));
    // TODO add styling for centering footer at sign in
    return (
        <>
        {alignment === 'center' ? (
            <div className="container-fluid noprint mt-4" id="footer_section">
                <div className="d-flex flex-column align-items-center text-center mb-2">
                  <div>
                    <a href="#about" onClick={() => navigate('#about')}>About</a>{' '}
                    <span className="menu-divider">&bull;</span>{' '}
                    <a href="#terms" onClick={() => navigate('#terms')}>Terms of Service</a>{' '}
                    <span className="menu-divider">&bull;</span>{' '}
                    <a href="#contact" onClick={() => navigate('#contact')}>Contact</a>
                  </div>
                  <div className="smaller">
                    © 2010 - <span id="copyright">{new Date().getFullYear()}</span>{' '}
                    HealthLevel Inc. All rights reserved.
                  </div>
                </div>
              </div>
            ) : (
              <div className="row mx-auto noprint" id="footer_section">
                <div id="footer_container" className="col-12 col-lg-12 text-left">
                    <div id="footer" className={`footer-container row px-0 d-flex justify-content-${alignment} text-start`}>
                        <div className="col-12 px-0 text-center  col-sm-6 col-md-7 text-sm-left mb-3 mb-sm-0">
                            <div>
                                <a
                                    href="#about"
                                    id="ctl00_site_master_footer_container_link_about"
                                    onClick={() => navigate('#about')}
                                >
                                    About
                                </a>{' '}
                                <span className="menu-divider">&bull;</span>
                                <a href="#terms"
                                   onClick={() => navigate('#terms')}
                                >Terms of Service
                                </a>{' '}
                                <span className="menu-divider">&bull;</span>
                                <a href="#contact"
                                   onClick={() => navigate('#contact')}
                                >Contact
                                </a>
                            </div>
                            <div className="smaller">
                                © 2010 - <span id="copyright">{new Date().getFullYear()}</span> HealthLevel
                                Inc. All rights reserved.
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-5 px-0">
                            <div className="row text-center text-sm-right">
                                <div className="col-6">
                                    <div
                                        id="ctl00_app_master_footer_container_buildV"
                                        className="hidden-info"
                                    >{ currentUserData?.userTypeNum === 1 && appSettings?.buildVersion}</div>
                                </div>
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-12">
                                            <div
                                                id="refreshTimerIndicator"
                                                className="small"
                                                style={{
                                                    display: 'block',
                                                    fontSize: '10px',
                                                }}
                                            >
                                                <IdleWatcher 
                                                    idleTimeout={appSettings?.tokenExpirationInterval * 60 * 1000}
                                                    idleWarning="Your session expires in"
                                                    warningMins={2}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div
                                                id="idleTimerIndicator"
                                                className="small"
                                                style={{
                                                    display: 'block',
                                                    fontSize: '10px',
                                                }}
                                            ></div>
                                        </div>

                                        <div className="col-12">
                                            <div
                                                id="ctl00_app_master_footer_container_session_timeout"
                                                className="hidden-info"
                                            ></div>
                                        </div>
                                        {currentUserData && (
                                        <div className="col-12">
                                            <div
                                                id="ctl00_app_master_footer_container_div_hidden_info"
                                                className="hidden-info"
                                            >
                                                {appSettings?.applicationName}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </>
    )
}
